import "../Styles/styles.css";
import "../Styles/fonts.css";
import NavBarButtons from "./NavBarButtons";


function NavBar() {
  return (
    <div>
      <NavBarButtons/>
    </div>
  );
}

export default NavBar;
